var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.has_props)?_c('router-link',{class:_vm.default_button ? 'default-button button_small' : '',attrs:{"to":_vm.get_props}},[_vm._t("default")],2):_c('a',{attrs:{"href":"#"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }